import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Anchor, Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/Button';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu when route changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);
  const navLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Menu',
    href: '/menu'
  }, {
    name: 'Reservations',
    href: '/reservations'
  }, {
    name: 'Careers',
    href: '/careers'
  }, {
    name: 'Contact',
    href: '/contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled || isMobileMenuOpen ? 'bg-navy-900/95 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-115">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <div className="flex justify-between items-center" data-id="element-117">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group" data-id="element-118">
            <Anchor className="h-8 w-8 text-gold-500 transition-transform duration-300 group-hover:rotate-12" data-id="element-119" />
            <span className="font-heading font-bold text-2xl tracking-wider text-white" data-id="element-120">
              THE DOCK WALL
            </span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-121">
            {navLinks.map(link => <Link key={link.name} to={link.href} className={`relative font-heading font-semibold text-sm uppercase tracking-widest transition-colors group ${location.pathname === link.href ? 'text-white' : 'text-gray-300 hover:text-white'}`} data-id="element-122">
                {link.name}
                <span className={`absolute -bottom-1 left-0 h-0.5 bg-ocean-500 transition-all duration-300 ${location.pathname === link.href ? 'w-full' : 'w-0 group-hover:w-full'}`} data-id="element-123" />
              </Link>)}
            <Link to="/reservations" data-id="element-124">
              <Button variant="primary" size="sm" data-id="element-125">
                Book a Table
              </Button>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button className="md:hidden text-white p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-126">
            {isMobileMenuOpen ? <X data-id="element-127" /> : <Menu data-id="element-128" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-129">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-navy-900 border-t border-navy-800 overflow-hidden" data-id="element-130">
            <div className="px-4 py-6 space-y-4 flex flex-col items-center" data-id="element-131">
              {navLinks.map(link => <Link key={link.name} to={link.href} className={`font-heading font-bold text-lg transition-colors ${location.pathname === link.href ? 'text-gold-500' : 'text-white hover:text-gold-500'}`} data-id="element-132">
                  {link.name}
                </Link>)}
              <Link to="/reservations" className="w-full max-w-xs" data-id="element-133">
                <Button variant="primary" className="w-full" data-id="element-134">
                  Book a Table
                </Button>
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}